import * as React from 'react';
import {Link} from 'react-router-dom';
import TopbarNav from '../topbar_with_navigation/topbar_nav/topbar_nav';
import TopbarSidebarButton from '../../../../theme/pages/_layout/topbar_with_navigation/TopbarSidebarButton';
import TopbarProfile from './topbar-profile';

class TopbarWithNavigation extends React.PureComponent {

    public render() {
        return (
            <div className='topbar topbar--navigation'>
                <div className='topbar__wrapper'>
                    <div className='topbar__left'>
                        <TopbarSidebarButton/>
                        <Link className='topbar__logo' to='/portada'/>
                    </div>
                    <TopbarNav/>
                    <div className='topbar__right'>
                        <TopbarProfile/>
                    </div>
                </div>
            </div>
        )
    }
}

export default (TopbarWithNavigation);


// WEBPACK FOOTER //
// ./src/components/common/layout/topbar_with_navigation/topbar-with-navigation.tsx